import createReactComponent from '../createReactComponent';
export default createReactComponent('zodiac-pisces', 'IconZodiacPisces', [
  ['path', { d: 'M5 3a21 21 0 0 1 0 18', key: 'svg-0' }],
  ['path', { d: 'M19 3a21 21 0 0 0 0 18', key: 'svg-1' }],
  ['path', { d: 'M5 12l14 0', key: 'svg-2' }],
]);
